import React from "react";
import { Platform, StyleSheet } from "react-native";

import { isNative } from "@stepapp/core";
import { Block, SvgIcon, Typography, palette, spacing } from "@stepapp/ui";
import { useTranslation } from "react-i18next";

type Transform = {
  rotate?: string;
  translateX?: number;
  translateY?: number;
};

type Props = {
  text?: string;
  placement?: "left" | "right";
  transform?: Transform[];
};

const OptionRibbon = ({ text, placement = "right", transform }: Props) => {
  const { t } = useTranslation();
  const placementRight = placement === "right";
  const customTransform = transform
    ? transform
    : [{ rotate: "-45deg" }, { translateX: 24 }, { translateY: 55 }];

  return (
    <Block
      alignCenter
      justifyCenter
      style={[
        styles.badge,
        placementRight ? styles.placementRight : styles.placementLeft,
        { transform: customTransform },
        isNative ? (placementRight ? styles.rightShadow : styles.leftShadow) : styles.shadowWeb,
      ]}
    >
      <Typography type="white" variant="badge">
        {text || t("common.popular")}
      </Typography>
      <Block>
        <SvgIcon color="white" name="star-outline" size={16} />
      </Block>
    </Block>
  );
};

export default React.memo(OptionRibbon);

const styles = StyleSheet.create({
  badge: {
    backgroundColor: palette.primary.pinkSalmon,
    elevation: 2,
    paddingHorizontal: spacing.unit * 4,
    position: "absolute",
    width: 140,
    ...Platform.select({
      default: {
        shadowColor: palette.primary.pinkSalmon,
        shadowOpacity: 0.2,
        shadowRadius: 8,
      },
      web: {},
    }),
  },
  leftShadow: Platform.select({
    default: {
      shadowOffset: { width: 0, height: 4 },
    },
    web: {},
  }),
  placementLeft: {
    flexDirection: "column-reverse",
    height: 44,
    left: 0,
    width: 136,
  },
  placementRight: {
    height: 50,
    paddingBottom: 6,
    right: 0,
    width: 140,
  },
  rightShadow: Platform.select({
    default: {
      shadowOffset: { width: 0, height: -4 },
    },
    web: {},
  }),
  shadowWeb: {
    boxShadow: "2px 2px 10px 0px rgba(244, 144, 144, 0.5)",
  },
});
